var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 登录用户："),_c('h2',[_vm._v(_vm._s(_vm.$store.state.user.Authorization.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }